import { useEffect, useState } from "react";
import Api from "../../services/Api";
import { useLocation, useNavigate } from 'react-router-dom';
import { TableBodyClass, headerTable } from "../../services/Utility";
import moment from "moment";
import Spinner from "../../components/Spinner";
import pluralize from "pluralize";


function DashboardTable(props) {
    const [tableData, settableData] = useState([])
    const [tableOrgDtata, setOrgtableData] = useState([])
    const [isLoading, setLoading] = useState(false)
    const [projects, setProjects] = useState([])
    const [users, setUsers] = useState([])
    const { project_id } = props;

    const location = useLocation()
    const navigate = useNavigate()
    useEffect(() => {
        getTableData()
        if (props.apiLink == "ropa") {
            getDropdownValues()
        }
    }, [location, project_id])
    const getDropdownValues = async () => {
        const data = await Api.getTableData("users");

        if (data) {

            const userData = data.data.data.results.map(item => {
                const obj = {
                    value: item.id,
                    label: item.name
                }
                return obj;
            })

            setUsers(userData)
        }

        const dataProject = await Api.getTableData("projects");

        if (dataProject) {

            const projectDatas = dataProject.data.data.results.map(item => {
                const obj = {
                    value: item.id,
                    label: item.name
                }
                return obj;
            })

            setProjects(projectDatas)
        }
    }
    const getTableData = async () => {
        setLoading(true)
        let data;
        if (project_id) {
            data = await Api.getTableData(props.apiLink, project_id);
        }
        else {
            data = await Api.getTableData(props.apiLink);
        }
        setLoading(false)
        if (data?.status == 401)
            navigate("/login")
        else if (data) {
            settableData(data.data.data.results)
            setOrgtableData(data.data.data.results)
        }
    }
    const handleSearch = (event) => {
        const search = event.target.value;
        settableData(tableOrgDtata.filter((item) =>
            item.name.includes(search)
        ))
    };

    const addForm = () => {
        navigate(`/dashboard/${props.classes}/create`)
    }

    const handleDropdown = (e) => {
        e.stopPropagation()
        console.log(e)
    }
    return (
        <div>
            <div className="container flex justify-between mb-8 mx-auto">
                <h1 style={{ width: '100%', fontSize: 20, fontWeight: 'bold', display: 'flex', alignItems: 'center' }}>{props.type}</h1>
                <div className="container flex justify-end">
                    <div className="flex items-center border-2 rounded">
                        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 mr-2 text-gray-600 ml-2" fill="none" viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                        <input type="text" name="Name" placeholder="Name" onChange={handleSearch}
                            style={{ background: "transparent" }}
                            className="w-1/3 py-2   outline-none focus:none" />
                    </div>
                    {props.create &&
                        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-2"
                            onClick={() => addForm()}>
                            {"Add " + (props.classes !== 'ROPA' ? pluralize.singular(props.classes).replace(/([A-Z])/g, ' $1').trim() : props.classes)}
                        </button>
                    }
                </div>
            </div>
            <div className="overflow-x-auto relative">

                <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400 data-table">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            {headerTable(props.classes).map(item =>
                                <th scope="col" className="py-3 px-6 min-w-50 text-white">
                                    {item}
                                </th>
                            )}

                        </tr>
                    </thead>
                    <tbody>
                        {(props.classes === "PrivacyRequests" || props.classes === "ROPA") ?
                            tableData && tableData.length > 0 && tableData.map(item =>


                                <tr className="cursor-pointer bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                                    onClick={() => navigate(`/dashboard/${props.classes}/create?id=${item.id}`)}>
                                    {TableBodyClass(props.apiLink).map(itemCol =>                                        
                                        <td className="py-4 px-6" style={{ minWidth: itemCol.minWidth + "px" }}
                                        // onClick={(event)=>itemCol.type=="select" && handleDropdown(event)}
                                        >
                                            {itemCol.type == "date" ? item[itemCol.name] ? moment(item[itemCol.name]).utc().format('YYYY-MM-DD') : "N/A" :
                                                itemCol.name == "project_id" ? item.project?.name : itemCol.name == "assigned_to_id" ? item.assigned_to?.name :
                                                    item[itemCol.name] === true ? "Yes" : item[itemCol.name] === "No" ? false : item[itemCol.name]}
                                        </td>
                                    )}
                                </tr>

                            )
                            :
                            tableData && tableData.length > 0 && tableData.map(item =>

                                <tr className="cursor-pointer bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                                    onClick={() => navigate(`/dashboard/${props.classes}/create?id=${item.id}`)}>
                                    <th scope="row" className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                        {props.classes === "TermsOfUse" ? item.language_code :
                                            props.classes === "PrivacyPolicies" ? item.language_code :
                                                props.classes === "users" ? item.name :
                                                    props.classes === "ROPA" ? item.name :
                                                        item.name}
                                    </th>
                                    <td className="py-4 px-6">
                                        {props.classes === "TermsOfUse" ? moment(item.terms_of_use_date).utc().format('YYYY-MM-DD') :
                                            props.classes === "RequestTypes" ? item.trigger_api_url :
                                                props.classes === "PrivacyPolicies" ? moment(item.privacy_policy_date).utc().format('YYYY-MM-DD') :
                                                    props.classes === "users" ? item.email_address :
                                                        props.classes === "DataSubjectTypes" ? item.project?.name :
                                                            item.dp_handle}

                                    </td>
                                    <td className="py-4 px-6">
                                        {props.classes === "TermsOfUse" ? item.terms_of_use_url :
                                            props.classes === "Projects" ? item.email_from :
                                                props.classes === "RequestTypes" ? item.trigger_api_method :
                                                    props.classes === "PrivacyPolicies" ? item.privacy_policy_url :
                                                        props.classes === "users" ? item.tenant?.email_domains :
                                                            props.classes === "DataSubjectTypes" ? item.tenant?.name :
                                                                item.email_domains}
                                    </td>
                                    <td className="py-4 px-6">

                                        {moment(item.created_at).utc().format('YYYY-MM-DD')}
                                    </td>
                                </tr>

                            )
                        }
                    </tbody>
                </table>
            </div>

            {isLoading &&
                <Spinner />}
        </div>

    );
}

export default DashboardTable;